<template>
  <b-row class="grab">
    <b-col class="col-main-pad">
      <b-row>
        <b-col lg="12" class="col-head-activity">
          <font-awesome-icon icon="border-none" />&nbsp; Configurar Crucigrama
        </b-col>
        <b-col lg="12">
          <b-form-group>
            <label for="name">Instrucciones de la Actividad</label>
            <b-form-textarea
              v-model="instrucciones"
              placeholder="Ingrese las Instrucciones para Realizar la Actividad"
              rows="2"
              max-rows="3"
            ></b-form-textarea>
          </b-form-group>
        </b-col>

        <b-col lg="6">
          <b-form-group>
            <label for="name">No. de Celdas Horizontales</label>
            <b-form-select
              :value="celdasH"
              id="celdasHNumero"
              class="border-visible"
              :options="noCeldas"
              @change="onChangeCeldas($event,'h')"
              variant="primary"
            >
              <template slot="first">
                <option :value="null" disabled>Seleccione un Número</option>
              </template>
            </b-form-select>
          </b-form-group>
        </b-col>
        <b-col lg="6">
          <b-form-group>
            <label for="name">No. de Celdas Verticales</label>
            <b-form-select
              :value="celdasV"
              id="celdasVNumero"
              class="border-visible"
              :options="noCeldas"
              @change="onChangeCeldas($event,'v')"
              variant="primary"
            >
              <template slot="first">
                <option :value="null" disabled>Seleccione un Número</option>
              </template>
            </b-form-select>
          </b-form-group>
        </b-col>

        <b-col lg="12" style="text-align: right;">
          <button type="button" class="btn btn-primary" @click="generarGrid">Generar Grid</button>
        </b-col>
      </b-row>

      <b-row v-if="matrixSelected.length > 0">
        <div class="container">
          <table>
            <tr v-for="(row, y) in matrixSelected" :key="y">
              <td
                v-for="(cell, x) in row"
                :key="x"
                @click="selectTd(x,y)"
                :class="{empty: cell.empty, selected: palabraData.pos[0] == x && palabraData.pos[1] == y, 'cursor-p':nuevaPalabra}"
              >{{cell.letter}}</td>
            </tr>
          </table>
        </div>
      </b-row>
      <b-row v-if="matrixSelected.length > 0">
        <b-col lg="12" style="text-align: right;">
          <button type="button" class="btn btn-primary" @click="agregarNuevaPalabra">
            <i class="icon-plus"></i>&nbsp;
            <span class="span-i-text">Nueva Palabra</span>
          </button>
        </b-col>
      </b-row>
      <b-row v-if="nuevaPalabra">
        <b-list-group>
          <b-list-group-item>
            <span>1. Selecciona del grid el cuadro donde empezará la palabra a agregar</span>
          </b-list-group-item>
          <b-list-group-item v-if="palabraData.pos.length > 0">
            <p>2. Selecciona el sentido de la palabra</p>
            <b-form-select
              v-model="palabraData.sentido"
              :options="optionsPos"
              @change="getSentido($event)"
            ></b-form-select>
          </b-list-group-item>
          <b-list-group-item v-if="palabraData.pos.length > 0 && palabraData.sentido != null">
            <p>3. Ingresa la palabra</p>
            <b-form-input
              v-model="palabraData.palabra"
              class="text-uppercase"
              placeholder="Ingresa una palabra"
            ></b-form-input>
          </b-list-group-item>
          <b-list-group-item v-if="palabraData.pos.length > 0 && palabraData.sentido != null">
            <p>4. Ingresa una pista</p>
            <b-form-input v-model="palabraData.pista" placeholder="Ingresa una pista"></b-form-input>
            <button
              type="button"
              class="btn btn-primary"
              style="margin-top: 20px; float: right;"
              @click="agregarPalabraCrucigrama"
            >
              <i class="icon-plus"></i>&nbsp;
              <span class="span-i-text">Agregar al crucigrama</span>
            </button>
          </b-list-group-item>
        </b-list-group>
      </b-row>
      <b-row v-if="palabrasSelected.length > 0">
        <p style="width: 100%; text-align: center;">Lista de las palabras agregadas al crucigrama</p>
        <b-col>
          <b-list-group>
            <b-list-group-item
              v-for="(p,i) in palabrasSelected"
              :key="i"
              style="border: 1px solid rgba(0, 0, 0, 0.125) !important;"
            >
              <span>{{i+1}}. {{p.palabra}}</span>
              <br />
              <span>
                <strong>Pista:</strong>
                {{p.pista}}
              </span>
              <span style="float: right;">
                <i
                  class="icon-trash"
                  style="color: red; margin: 0 5px; font-size: 16px; cursor: pointer;"
                  v-b-tooltip.hover
                  title="Eliminar"
                  @click="removePalabra(i)"
                ></i>
                <i
                  class="icon-pencil"
                  style="color: #20a8d8; margin: 0 5px; font-size: 16px; cursor: pointer;"
                  v-b-tooltip.hover
                  title="Editar"
                  @click="editPalabra(p)"
                ></i>
              </span>
            </b-list-group-item>
          </b-list-group>
        </b-col>
      </b-row>
    </b-col>
    <!-- componente de botón de opciones del elemento  -->
    <options-element :index-element="idElement" :index-column="idColumn"></options-element>
  </b-row>
</template>

<script>
// Objeto default para celdas vacías de la grilla
const empty = {
  start: false,
  letter: "",
  words: [],
  empty: true
};

var arry = new Array(20);
var noCeldas = [];
for (let i = 1; i < arry.length; i++) {
  noCeldas.push(i);
}
import OptionsElement from "./OptionsElement";
export default {
  name: "Crucigrama",
  props: {
    palabras: {
      type: Array,
      default: () => {
        return new Array();
      }
    },
    matrix: {
      type: Array,
      default: () => {
        return new Array();
      }
    },
    desc: { type: String },
    idElement: { type: Number },
    idColumn: { type: Number, default: null },
    horizontal: { type: Number, default: null },
    vertical: { type: Number, default: null }
  },
  data() {
    return {
      selected: undefined,
      instrucciones: this.desc,
      noCeldas: noCeldas,
      celdasH: this.horizontal,
      celdasV: this.vertical,
      matrixSelected: this.matrix,
      nuevaPalabra: false,
      palabrasSelected: this.palabras,
      optionsPos: [
        { value: null, text: "Selecciona una posición" },
        { value: 0, text: "Horizontal" },
        { value: 1, text: "Vertical" }
      ],
      palabraData: {
        pos: [],
        sentido: null,
        palabra: "",
        pista: ""
      }
    };
  },
  components: {
    OptionsElement
  },
  methods: {
    onChangeCeldas(e, pos) {
      if (pos == "h") {
        this.celdasH = e;
      }
      if (pos == "v") {
        this.celdasV = e;
      }
      console.log(e);
      console.log(pos);
    },
    generarGrid() {
      this.matrixSelected = Array(this.celdasV)
        .fill(0)
        .map(() => Array(this.celdasH).fill(empty));
    },
    selectTd(x, y) {
      if (this.nuevaPalabra) {
        this.palabraData.pos = [];
        this.palabraData.pos.push(x);
        this.palabraData.pos.push(y);
      }
    },
    agregarNuevaPalabra() {
      this.nuevaPalabra = true;
      console.log(this.palabraData);
    },
    getSentido(value) {
      this.palabraData.sentido = value;
    },
    agregarPalabraCrucigrama() {
      console.log(this.palabraData);
      this.palabrasSelected.push(this.palabraData);
      this.palabrasSelected.forEach((palabra, index) => {
        const [x, y] = palabra.pos;
        palabra.palabra.split("").forEach((l, i) => {
          let cell = this.matrixSelected[y + (palabra.sentido ? i : 0)][
            x + (palabra.sentido ? 0 : i)
          ];
          if (cell === empty) {
            cell = this.matrixSelected[y + (palabra.sentido ? i : 0)][
              x + (palabra.sentido ? 0 : i)
            ] = { words: [] };
          }
          cell.empty = false;
          cell.words.push(index);
          if (i === 0) {
            cell.start = index + 1;
          }
          cell.letter = l;
        });
      });

      this.refreshPalabraData();
    },
    refreshPalabraData() {
      this.nuevaPalabra = false;
      this.palabraData = {
        pos: [],
        sentido: null,
        palabra: "",
        pista: ""
      };
    },
    refreshAfterEdit() {
      this.generarGrid();
      this.palabrasSelected.forEach((palabra, index) => {
        const [x, y] = palabra.pos;
        palabra.palabra.split("").forEach((l, i) => {
          let cell = this.matrixSelected[y + (palabra.sentido ? i : 0)][
            x + (palabra.sentido ? 0 : i)
          ];
          if (cell === empty) {
            cell = this.matrixSelected[y + (palabra.sentido ? i : 0)][
              x + (palabra.sentido ? 0 : i)
            ] = { words: [] };
          }
          cell.empty = false;
          cell.words.push(index);
          if (i === 0) {
            cell.start = index + 1;
          }
          cell.letter = l;
        });
      });
    },
    removePalabra(i) {
      this.$swal
        .fire({
          title: "Eliminar una Palabra",
          text: "¿Seguro que desea eliminar la palabra seleccionada?",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#285c4d",
          cancelButtonColor: "#aaa",
          confirmButtonText: "Sí, Eliminar",
          cancelButtonText: "No, Cancelar"
        })
        .then(result => {
          if (result.value) {
            this.palabrasSelected.splice(i, 1);
            setTimeout(() => {
              this.refreshAfterEdit();
            }, 500);
          }
        });
    },
    async editPalabra(p) {
      console.log(p);
      const { value: formValues } = await this.$swal.fire({
        title: "Editar una Palabra",
        text: "Edita el texto de la palabra y la pista asociada",
        html:
          '<input id="swal-input1" value="' +
          p.palabra +
          '" class="swal2-input input-default">' +
          '<input id="swal-input2" value="' +
          p.pista +
          '" class="swal2-input input-default">',
        confirmButtonColor: "#285c4d",
        cancelButtonColor: "#aaa",
        confirmButtonText: "Guardar Cambios",
        cancelButtonText: "Cancelar",
        preConfirm: () => {
          return [
            document.getElementById("swal-input1").value,
            document.getElementById("swal-input2").value
          ];
        }
      });

      if (formValues) {
        console.log(formValues);
        p.palabra = formValues[0];
        p.pista = formValues[1];
        this.refreshAfterEdit();
        //this.$swal.fire(JSON.stringify(formValues));
      }
    }
  },
  watch: {
    palabrasSelected: {
      handler: function(change) {
        this.$store.dispatch("constructor/updateContentElement", {
          indexElement: this.idElement,
          data: change,
          field: "palabras",
          indexColumns: this.idColumn
        });
      },
      deep: true
    },
    matrixSelected: {
      handler: function(change) {
        this.$store.dispatch("constructor/updateContentElement", {
          indexElement: this.idElement,
          data: change,
          field: "matrix",
          indexColumns: this.idColumn
        });
      },
      deep: true
    },
    instrucciones: function(change) {
      this.$store.dispatch("constructor/updateContentElement", {
        indexElement: this.idElement,
        data: change,
        field: "instrucciones",
        indexColumns: this.idColumn
      });
    },
    celdasH: function(change) {
      this.$store.dispatch("constructor/updateContentElement", {
        indexElement: this.idElement,
        data: change,
        field: "horizontal",
        indexColumns: this.idColumn
      });
    },
    celdasV: function(change) {
      this.$store.dispatch("constructor/updateContentElement", {
        indexElement: this.idElement,
        data: change,
        field: "vertical",
        indexColumns: this.idColumn
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  margin-top: 3vh;
}
.table-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
table {
  border-collapse: collapse;
  font-size: 18px;
  margin: 0 auto;
}
td {
  width: 36px;
  height: 36px;
  border: 1px solid black;
  text-align: center;
  position: relative;
  text-transform: uppercase;
  font-family: arial;
  cursor: default;
}
td.empty {
  background: #eceff1;
}
td.selected {
  background: lightblue;
}
.cursor-p {
  cursor: pointer !important;
}
.input-default {
  margin: 5px 0 !important;
}
.swal2-popup .swal2-input {
  margin: 5px 0 !important;
}
.swal2-popup #swal2-content {
  text-align: left !important;
}
.list-group-item {
  border: none !important;
}
</style>